// Color utilities
export const getLeadTemperatureColor = (leadType) => {
    const type = leadType?.toLowerCase() || '';
    
    if (type.includes('warm') || type.includes('hot')) {
      return {
        name: 'orange',
        light: '#FFFBEB',
        bgLight: 'bg-orange-50',
        border: '#FED7AA',
        text: 'text-orange-600',
        dark: '#C2410C',
      };
    } else if (type.includes('cold')) {
      return {
        name: 'green',
        light: '#ECFDF5',
        bgLight: 'bg-green-50',
        border: '#A7F3D0',
        text: 'text-green-600',
        dark: '#047857',
      };
    } else {
      return {
        name: 'blue',
        light: '#EFF6FF',
        bgLight: 'bg-blue-50',
        border: '#BFDBFE',
        text: 'text-blue-600',
        dark: '#1D4ED8',
      };
    }
  };
  
  export const getLeadStatusColor = (status) => {
    const normalizedStatus = status?.toLowerCase() || '';
  
    switch (normalizedStatus) {
      case 'new':
        return 'success';
      case 'contacted':
        return 'info';
      case 'qualified':
        return 'primary';
      case 'converted':
        return 'success';
      case 'disqualified':
        return 'error';
      default:
        return 'default';
    }
  };
  
  // Date formatting utility
  export const formatDate = (dateString) => {
    if (!dateString) return '';
    
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    } catch (error) {
      console.error('Error formatting date:', error);
      return dateString;
    }
  };